<template>
    <div class="autoreg">
        <h3 class="autoreg-title">免注册登录</h3>
        <p class="autoreg-tips">免注册快速体验游戏，绑定账号后保存游戏记录</p>
        <div class="autoreg-form"
             id="area">
            <Loading></Loading>
            <p v-text="geeTxt"></p>
        </div>
        <div class="moreMethods"
             @click="fnSwitchLoger('normal')">使用其他方式登录>></div>
    </div>
</template>

<script>
import Loading from '../common/Loading'
export default {
    name: 'autoreg',
    data () {
        return {
            captchaObj: null,
            geeTxt: '加载中...'
        }
    },
    mounted () {
        let t = this
        t.captchaObj && t.captchaObj.reset()
        t.fnGeeInit(function (geeData) {
            t.autoReg(geeData)
        }, 'autoreg')
    },
    methods: {
        fnSwitchLoger (type) {
            this.captchaObj && this.captchaObj.destroy()
            this.$emit('fnBtnClick', type)
        },
        autoReg (geeData) {
            let t = this
            geeData = geeData || {}
            geeData.source_page = ELSDK.SourcePage.box || 'yilewan_pcbox'
            geeData.attr = t.$cookies.get('jsGameCode') ? 'game' : ''
            geeData.attr_value = t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : ''
            geeData.game_code = t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : ''
            ELSDK.SDKAPI('autoreg', geeData, (res) => {
                if (res.status === 'error') {
                    t.Toast({ content: res.msg })
                    return
                }
                t.geeTxt = '登录检验中...'
                t.$emit('fnGetYilewanToken', 1)
            })
        },
        // 极验初始化
        fnGeeInit (fn, type) {
            let t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('geeInit', { type: type }, (captchaObj) => {
                // debugger
                t.captchaObj = captchaObj
                if (type === 'autoreg') {
                    setTimeout(function () { t.captchaObj.verify() }, 1000)
                }
                t.captchaObj.onSuccess(function () {
                    let result = t.captchaObj.getValidate()
                    if (!result) {
                    } else {
                        let geeData = {
                            gee_client_type: 'web',
                            gee_challenge: result.geetest_challenge,
                            gee_validate: result.geetest_validate,
                            gee_seccode: result.geetest_seccode
                        }
                        fn && fn(geeData)
                    }
                })
            })
        }
    },
    components: {
        Loading
    }
}
</script>

<style lang="less">
</style>
